import React from 'react';
import FormRadio from './FormRadio';

const valueCardGroup = props => {
  const {
    selectedValue, possibleValues, name,
    readOnly, required, rest
  } = props;

  return Array.from(possibleValues)
    .filter(([key]) => !readOnly || (readOnly && selectedValue === key))
    .map(([key, value], index) => (
      <FormRadio
        selectedValue={readOnly ? false : selectedValue}
        key={key}
        name={name}
        text={value}
        value={key}
        required={required && index === 0}
        {...rest}
      />));
};

export default valueCardGroup;



// WEBPACK FOOTER //
// ./src/pages/Helpers/Form/RadioValues.js